import { SegmentEvent } from 'src/types/segment';

import { fetchWithRetry } from './fetch-with-retry';

export const sendSegmentEvent = async (
  event: string,
  entityId: string | null,
  properties: Omit<SegmentEvent, 'event'>
) => {
  if (!process.env.SEGMENT_HOST || !process.env.SEGMENT_KEY) {
    // eslint-disable-next-line no-console
    console.error('Segment configuration is missing');
    return;
  }

  const payload = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      anonymousId: entityId,
      type: 'track',
      event,
      writeKey: process.env.SEGMENT_KEY,
      properties,
    }),
  };

  try {
    await fetchWithRetry({
      url: `https://${process.env.SEGMENT_HOST}/t`,
      options: payload,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to send segment event:', error);
  }
};
